const scrollPositions = new Map();

export const saveScrollPosition = (url) => {
    scrollPositions.set(url, window.scrollY);
};

export const getScrollPosition = (url) => {
    return scrollPositions.get(url) || 0;
};
